import { IExpense } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		expenseNo?: number
		date?: number
		categoryId?: string
		fields?: {
			fieldId: string
			value: any
		}[]
	}
}

export async function expenseUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/expense/update/v1"
	const requester = new ApiRequester<RequestDataShape, IExpense>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
